import { useEffect, useLayoutEffect, useState } from 'react';
import './predictiveSelect.scss';

interface PredictiveSelectInterface {
  name: string;
  label: string;
  options: any[];
  register: any;
  setValue: any;
  errors?: any;
  validationRules?: any;
  required?: boolean;
  square?: boolean;
  error?: any;
  onChange?: any;
  loader?: boolean;
  disabled?: boolean;
  defaultValue?: any;
  id?: string;
  onDisplayEvent?: any;
  onSelectEvent?: any;
  forceChangeValue?: any;
  role?: string;
  isDefaultValue?: boolean;
  getValues?: any;
  placeholder: string;
}

const PredictiveSelect = ({
  name,
  options,
  label,
  register,
  validationRules,
  error,
  id,
  onChange,
  setValue,
  defaultValue,
  onDisplayEvent,
  onSelectEvent,
  forceChangeValue,
  required,
  square,
  role,
  disabled = false,
  isDefaultValue = false,
  placeholder,
}: PredictiveSelectInterface) => {
  const [currentOption, setCurrentOption] = useState<any>();
  const [selectedValue, setSelectedValue] = useState<any>();
  const [opened, setOpened] = useState(false);
  const [valueToSearch, setValueToSearch] = useState('');

  useEffect(() => {
    if (!options.length) return;
    {
      options[0] && setValue(name, options[0].value);
      setCurrentOption(options[0].name);
    }
  }, []);

  useEffect(() => {
    if (isDefaultValue) {
      setCurrentOption(defaultValue.name);
    }
    if (!defaultValue) {
      setValue(name, options[0].value);
      setCurrentOption(options[0].name);
    } else if ((defaultValue && currentOption === defaultValue.name) || !currentOption) {
      setValue(name, defaultValue.value);
      setCurrentOption(defaultValue.name);
    }
  }, [defaultValue]);

  useEffect(() => {
    if (forceChangeValue) {
      selectForcedOption(forceChangeValue.name, forceChangeValue.value);
    }
  }, [forceChangeValue]);

  useLayoutEffect(() => {
    if (name === 'requestType') {
      setCurrentOption('Selecciona');
      setValue('requestType', '');
    }
  }, [options]);

  const selectOption = (optionName, value) => {
    const select = document.getElementById(`${id}select`);
    const option = document.getElementById(`${id}options`);
    const currentOption = document.getElementById(`${id}currentOption`);
    if (select && option && currentOption) {
      select.classList.toggle('__active');
      select.classList.remove('__error');
      option.classList.toggle('__active');
      currentOption.classList.toggle('__active');
    }
    setValue(name, value);
    setCurrentOption(optionName);
    onChange(optionName, value);

    if (label) {
      const labelName = document.getElementById(name + label);
      labelName && labelName.classList.remove('__visible');
    }

    setOpened(false);
  };

  const selectForcedOption = (optionName, value) => {
    setValue(name, value);
    setCurrentOption(optionName);
    onChange(optionName, value);

    setOpened(false);
  };

  const displayOption = () => {
    const select = document.getElementById(`${id}select`);
    const options = document.getElementById(`${id}options`);
    const currentlyOption = document.getElementById(`${id}currentOption`);
    if (label) {
      const labelName = document.getElementById(name + label);
      labelName && labelName.classList.toggle('__visible');
    }
    if (select && options && currentlyOption) {
      select.classList.toggle('__active');
      options.classList.toggle('__active');
      currentlyOption.classList.toggle('__active');
    }
  };

  const filterOptions = () => {
    if (valueToSearch.length >= 4) {
      const result = options.filter((ele: any) => {
        return ele.name.toLocaleLowerCase().includes(valueToSearch.toLocaleLowerCase());
      });
      if (valueToSearch === '') {
        return options;
      }
      if (result.length > 0) {
        return result;
      }
    }

    return options;
  };

  return (
    <div className={`f-a-selectBox ${square ? ' __square' : ''}`} role={role}>
      {label && (
        <label
          id={name + label}
          htmlFor={name}
          className={`f-a-selectBox__label${required ? ' __required' : ''}`}
        >
          {label}
        </label>
      )}
      {opened && (
        <div
          data-testid="btn1"
          className="f-a-selectBox__background"
          onClick={() => {
            if (!disabled) {
              displayOption();
              setOpened(false);
            }
          }}
        />
      )}
      <div
        data-testid="btn2"
        tabIndex={0}
        className={`f-a-selectBox__select ${error ? '__error' : ''}`}
        id={`${id}select`}
        onClick={() => {
          if (!disabled) {
            {
              onDisplayEvent && onDisplayEvent();
            }
            setOpened(!opened);
            displayOption();
          }
        }}
      >
        <div className="f-a-selectBox__select-inner">
          <div className="f-a-selectBox__select-content">
            <input
              data-testid="btn3"
              type="text"
              id={`${id}currentOption`}
              name={name}
              autoComplete="off"
              placeholder={placeholder}
              defaultValue={selectedValue}
              value={selectedValue}
              onClick={() => setOpened(true)}
              onChange={(e) => {
                setValueToSearch(e.target.value);
                setSelectedValue(e.target.value);
              }}
            />
          </div>
          {square ? (
            opened ? (
              <span className="icon-caret-up f-a-selectBox__icon" />
            ) : (
              <span className="icon-caret-down f-a-selectBox__icon" />
            )
          ) : opened ? (
            <span className="icon-chevron-up f-a-selectBox__icon" />
          ) : (
            <span className="icon-chevron-down1 f-a-selectBox__icon" />
          )}
        </div>
      </div>

      <ul className="f-a-selectBox__option-container" id={`${id}options`}>
        {options &&
          filterOptions().map((info, index) => {
            return (
              <li
                className="f-a-selectBox__option"
                key={index}
                onClick={() => {
                  {
                    onSelectEvent && onSelectEvent();
                  }
                  selectOption(info.name, info.value);
                  setSelectedValue(info.name);
                  setValueToSearch('');
                }}
              >
                <p>{info.name}</p>
              </li>
            );
          })}
      </ul>
      <input type="hidden" name={name} id={name} {...register(name, validationRules)} />
      {error && <span className="f-a-selectBox__error">{error.message}</span>}
    </div>
  );
};

// Especifica los valores por defecto de props:
PredictiveSelect.defaultProps = {
  id: 'f-a-',
  onChange: () => {},
};

export default PredictiveSelect;
